module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft--dark-af3993cbcdb7e8706e38002c2fd7bccf.png";